import { getNetwork } from "@wagmi/core";

export type ItoBlockExplorer = (v : string, type: 'tx'|'address') => Promise<string>;

export default async function toBlockExplorer(v : string, type: 'tx'|'address') {
    const network = await getNetwork()
    const networkName = network.chain?.id == 80001 ? 'MUMBAI' : 'POLYGON'
    const blockExplorerUrl = process.env[`VUE_APP_${networkName}_BLOCK_EXPLORER_URL`]!
    return `${blockExplorerUrl}${type}/${v}`
}